export const resultados = [
  { 
    porcentagem: '95%', 
    descricao: 'Controle vacinal' 
  },
  { 
    porcentagem: '40%', 
    descricao: 'Redução de perdas' 
  },
  { 
    porcentagem: '70%', 
    descricao: 'Economia de tempo' 
  },
  { 
    porcentagem: '100%', 
    descricao: 'Rastreabilidade' 
  }
];